import { ModuleRegistry } from '@ag-grid-community/core'
import { MasterDetailModule } from '@ag-grid-enterprise/master-detail'
import { Component, Inject, OnDestroy, OnInit, ViewChild } from '@angular/core'
import { ResizeHandleState } from '@helios/generic-components'
import { BasePanelComponent, LayoutContainer } from '@helios/panel-base'
import { RootState, selectFocusedAccounts } from '@helios/state-management'
import { Store } from '@ngrx/store'
import { ComponentContainer } from 'golden-layout'
import { Subject } from 'rxjs'
import {
  debounceTime,
  distinctUntilChanged,
  takeUntil,
  tap,
} from 'rxjs/operators'
import { RulesKey } from '../panel-key'
import { FindRulesPopoverComponent } from './find-rules-popover/find-rules-popover.component'
import { FindRulesForm } from './models/find-rules.model'

ModuleRegistry.registerModules([MasterDetailModule])

interface RulesPanelState {
  resizeHandleState: ResizeHandleState
}

@Component({
  selector: 'hs-rules',
  templateUrl: './rules-panel.component.html',
  styleUrls: ['./rules-panel.component.scss'],
})
export class RulesPanelComponent
  extends BasePanelComponent<RulesPanelState>
  implements OnDestroy, OnInit
{
  panelKey = RulesKey
  private readonly _destroyed$ = new Subject<void>()
  ruleIdSelected?: number
  isSearchPopoverShown = false
  isLoading = false
  searchInput?: FindRulesForm
  resetFilter = false

  @ViewChild('findRulePopover')
  readonly findRulePopover?: FindRulesPopoverComponent
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  focusedIds: number[] = []
  constructor(
    @Inject(LayoutContainer) container: ComponentContainer,
    private readonly store: Store<RootState>,
  ) {
    super(container)
  }
  ngOnInit(): void {
    this.store
      .select(selectFocusedAccounts)
      .pipe(
        takeUntil(this._destroyed$),
        debounceTime(500),
        distinctUntilChanged(),
        tap(selectedAccountId => {
          if (selectedAccountId) {
            this.setSelectedAccountId(selectedAccountId)
          }
        }),
      )
      .subscribe()
  }

  setSelectedAccountId(selectedAccountId: number[]) {
    this.focusedIds = selectedAccountId
  }

  setSelectedRuleId(id: number | undefined) {
    this.ruleIdSelected = id
  }

  ngOnDestroy(): void {
    this._destroyed$.next()
    this._destroyed$.complete()
  }

  onResizeFinished(resizeHandleState: ResizeHandleState) {
    this.setState({
      ...this.state,
      resizeHandleState,
    })
  }

  onSearchSubmit(form: FindRulesForm) {
    this.searchInput = form
  }

  resetPopOverFilter() {
    this.findRulePopover?.resetForm()
  }
}
